import { Button } from '@chakra-ui/react';
import NiceModal from '@ebay/nice-modal-react';
import { DsbForm, LooseObject } from 'api/types';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormEmbeddedAlertModal from '../../components/modals/FormEmbeddedAlertModal';
import { createDropdownPlainOptions } from '../../helpers/general';
import { dropdown } from '../../helpers/makeFormFields';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import MakeFormMappingCard from './MakeFormMappingCard';

export const updateFormButton = (props: {
  row: { original: LooseObject };
  forms: DsbForm[];
  t: any;
  sendRequest: (data: any) => Promise<any>;
  header: string;
  url: string;
}) => {
  const { row, forms, t, sendRequest, header, url } = props;

  return (
    <Button
      variant={'primary'}
      onClick={() => {
        NiceModal.show(FormEmbeddedAlertModal as any, {
          content: {
            header: header,
            formTestId: 'dsb-form-update',
            formFields: (props: { control: any; errors: any }) => {
              const { control, errors } = props;
              return (
                <>
                  {dropdown({
                    name: 'dsb_form_id',
                    label: t('pages:config_makes.table.columns.dsb_form'),
                    // @ts-ignore
                    control,
                    errors,
                    options: createDropdownPlainOptions({
                      records: forms,
                      valueColumn: 'id',
                      labelColumn: 'slug',
                    }),
                  })}
                </>
              );
            },
            footer: {
              buttons: {
                formButtonTestId: 'dsb-form-submit-button',
                actionCaption: t('common:edit'),
              },
            },
          },
          onMutate: (data: { dsb_form_id: number }) =>
            sendRequest({
              url,
              dataForEndpoint: {
                ...row.original,
                dsb_form_id: data?.dsb_form_id,
              },
            }),
          schema: yup
            .object({
              dsb_form_id: yup.number().required(),
            })
            .required(),
        });
      }}
    >
      {forms.find((form) => form?.id === row.original.dsb_form_id)?.slug}
    </Button>
  );
};

const ConfigureMakesOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:config_makes.meta.title')} />
      <MakeFormMappingCard />
    </ContentLayout>
  );
};

export default ConfigureMakesOverviewPage;
